<div #chartContainer class="jepto-column-chart-container"></div>
